import { apiClientManager } from '@common/api';
export async function getMachineConfig() {
    const res = await apiClientManager.getClient().request({
        method: 'GET',
        url: '/api/machine-config',
        headers: { Accept: 'application/json' }
    });
    return res.data;
}
export async function patchMachineConfig(patch) {
    const res = await apiClientManager.getClient().patch('/api/machine-config', patch);
    return res.data;
}
